/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BankDetailViewModel } from "../types/BankDetailViewModel.ts";

export const bankDetailViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  code: z.optional(z.number().int()),
  agency: z.string().nullish(),
  accountNumber: z.string().nullish(),
  name: z.string().nullish(),
  image: z.string().nullish(),
  merchant: z.string().nullish(),
  bankPortfolio: z.string().nullish(),
  currency: z.string().nullish(),
  placePayment: z.string().nullish(),
  address: z.string().nullish(),
  phone: z.string().nullish(),
  cnpj: z.string().nullish(),
  instructionDefault1: z.string().nullish(),
  instructionDefault2: z.string().nullish(),
  instructionDefault3: z.string().nullish(),
  serialNextValue: z.optional(z.number().int()),
  companyId: z.number().int().nullish(),
}) as unknown as ToZod<BankDetailViewModel>;
